import React from 'react';
import { Field, formValueSelector, reduxForm, change } from 'redux-form';
import validate from './validate';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from '../../../../../../shared/components/form/Select';
import { renderField } from '../../../../../../utils/helpers';
import renderDatePickerField from '../../../../../../shared/components/form/DatePicker';


let EditInvoiceForm = (props) => {
  const { handleSubmit, dispatch, business, selectCurrency, methods } = props;

  return (
    <>
      <Col className='col-12'>
        <h5 className='mb-2'>EDIT INVOICE</h5>
      </Col>
      <form className='form form-edit-invoice' onSubmit={handleSubmit}>
        <Col className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Customer</span>
            <div className='form__form-group-field'>
              <Field
                name='customer.name'
                component={renderField}
                type='input'
                disabled={true}
              />
            </div>
          </div>
        </Col>
        <Col className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Business</span>
            <div className='form__form-group-field'>
              <Field
                name='select_business'
                onChange={() => {
                  dispatch(change('editInvoiceForm', 'select_method', null))
                }}
                component={renderSelectField}
                id='business'
                options={business?.map(u => {
                  return {
                    value: u.id,
                    label: `${u.name}`,
                  };
                })}
              />
            </div>
          </div>
        </Col>
        <Col className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Payment method</span>
            <div className='form__form-group-field'>
              <Field
                name='select_method'
                component={renderSelectField}
                id='methods'
                options={methods?.map(u => {
                  return {
                    value: u.id,
                    label: `${u.name}`,
                  };
                })}
              />
            </div>
          </div>
        </Col>
        <Col md={6} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Date Start</span>
            <div className='form__form-group-field'>
              <Field
                name='start_date'
                component={renderDatePickerField}
              />
            </div>
          </div>
        </Col>
        <Col md={6} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Date End</span>
            <div className='form__form-group-field'>
              <Field
                name='end_date'
                component={renderDatePickerField}
              />
            </div>
          </div>
        </Col>
        <Col md={4} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Subtotal</span>
            <div className='form__form-group-field d-flex align-items-center'>
              <Field
                name='subtotal'
                component={renderField}
                type='input'
              />
            </div>
          </div>
        </Col>
        <Col md={4} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Discount</span>
            <div className='form__form-group-field d-flex align-items-center'>
              <Field
                name='discount'
                component={renderField}
                type='input'
              />
            </div>
          </div>
        </Col>
        <Col md={4} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Total</span>
            <div className='form__form-group-field d-flex align-items-center'>
              <Field
                name='total'
                component={renderField}
                type='input'
              />
            </div>
          </div>
        </Col>
        <Col md={6} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Currency</span>
            <div className='form__form-group-field d-flex align-items-center'>
              <Field
                name='select_currency'
                component={renderSelectField}
                id='currency'
                options={[{ id: 'USD', name: 'USD' }, { id: 'AUD', name: 'AUD' }, {
                  id: 'EUR',
                  name: 'EUR',
                }, { id: 'GBP', name: 'GBP' }]?.map(u => {
                  return {
                    value: u.id,
                    label: `${u.name}`,
                  };
                })}
              />
            </div>
          </div>
        </Col>
        {
          selectCurrency?.value && selectCurrency?.value !== 'USD' ? (
            <Col md={6} className='col-12'>
              <div className='form__form-group'>
                <span className='form__form-group-label'>Currency Exchange Rate</span>
                <div className='form__form-group-field d-flex align-items-center'>
                  <Field
                    name='exchange_rate'
                    component={renderField}
                    type='input'
                  />
                </div>
              </div>
            </Col>
          ) : null
        }
        <Col md={6} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>Notes</span>
            <div className='form__form-group-field d-flex align-items-center'>
              <Field
                name='notes'
                component={renderField}
                type='input'
              />
            </div>
          </div>
        </Col>
        <Col md={6} className='col-12'>
          <div className='form__form-group'>
            <span className='form__form-group-label'>VAT Percentage</span>
            <div className='form__form-group-field'>
              <Field
                name='vat_value'
                component={renderField}
                value={0}
                type='input'
              />
            </div>
          </div>
        </Col>
        <Col sm={12} className='d-flex justify-content-end w-100'>
          <button type='submit' className='btn btn-primary'>Save</button>
        </Col>
      </form>
    </>
  );
};

const selector = formValueSelector('editInvoiceForm');

EditInvoiceForm = reduxForm({
  form: 'editInvoiceForm',
  enableReinitialize: true,
  validate,
})(EditInvoiceForm);

EditInvoiceForm = connect(
  state => {
    const business = state?.editInvoice?.businesses;
    const invoice = state?.editInvoice?.editInvoice;

    let editInvoiceStartDate = invoice?.start_date || '';
    let editInvoiceEndDate = invoice?.end_date || '';

    let splitStartDate = editInvoiceStartDate?.split('/') || [];
    let startDate = `${splitStartDate[1]}/${splitStartDate[0]}/${splitStartDate[2]}`;
    let splitEndDate = editInvoiceEndDate?.split('/') || [];
    let endDate = `${splitEndDate[1]}/${splitEndDate[0]}/${splitEndDate[2]}`;

    let initialBussiness = {
      value: '',
      label: '',
    };

    let initialMethod = {
      value: '',
      label: '',
    };

    if (business.length && invoice) {
      for (const b of business) {
        for (const m of b.methods) {
          if (m.id === invoice.payment_method_id) {
            initialBussiness.value = b.id;
            initialBussiness.label = b.name;

            initialMethod.value = m.id;
            initialMethod.label = m.name;
            break;
          }
        }
      }
    }

    let methods = [];
    const selectedBusiness = selector(state, 'select_business');

    if (selectedBusiness?.value) {
      for (const b of business) {
        if (b.id === selectedBusiness.value) {
          methods = [...b.methods];
          break;
        }
      }
    }

    return {
      initialValues: {
        ...state.editInvoice.editInvoice,
        select_currency: {
          value: invoice?.currency,
          label: invoice?.currency,
        },
        select_business: initialBussiness,
        select_method: initialMethod,
        start_date: editInvoiceStartDate ? new Date(startDate) : null,
        end_date: editInvoiceEndDate ? new Date(endDate) : null,
        vat_value: invoice?.vat_value === null ? '0' : invoice?.vat_value,
      },
      editInvoice: invoice,
      selectCurrency: selector(state, 'select_currency'),
      business: business,
      methods: methods,
    };
  })(EditInvoiceForm);

export default EditInvoiceForm;